import { useState } from 'react';

import { SearchBox } from '@xingternal/crate-jobs-components';
import { useSearchLocation } from '@xingternal/crate-jobs-hooks';
import { ROUTES } from '@xingternal/crate-jobs-paths';

import {
  Background,
  BigScreenFilters,
  Box,
  SearchboxStartpageMetadata,
  SmallScreenFilters,
  Teaser,
  Title,
} from './components';

type Props = {
  withTeaser?: boolean;
  withRecentSearches?: boolean;
  withFilters?: boolean;
  spacious?: boolean;
  autofillBusinessCity?: boolean;
  isStartPage?: boolean;
};

const FULL_REMOTE_FILTER_VALUE = 'FULL_REMOTE.050e26';
const PART_TIME_FILTER_VALUE = 'PART_TIME.58889d';
const FLEXITIME_FILTER_VALUE = '1.795d28';

export const LandingSearchBar: React.FC<Props> = ({
  withTeaser = false,
  withRecentSearches = false,
  withFilters = false,
  spacious = false,
  autofillBusinessCity = false,
  isStartPage,
}) => {
  const [keywords, setKeywords] = useState('');
  const {
    location,
    radius,
    cityId,
    onChangeLocation,
    onSelectLocation,
    onSelectRadius,
  } = useSearchLocation({ skipBusinessCityQuery: !autofillBusinessCity });

  const trackingParameter = isStartPage
    ? '?sc_o=losp_jobs_search_button_click&sc_o_PropActionOrigin=losp_job_search'
    : '?sc_o=jobs_search_button';

  // Extra filters
  const [isFullRemote, setIsFullRemote] = useState(false);
  const [isPartTime, setIsPartTime] = useState(false);
  const [isFlexitime, setIsFlexitime] = useState(false);

  const onSubmit = (): void => {
    const params = new URLSearchParams(trackingParameter);

    if (keywords) {
      params.set('keywords', keywords);
    }
    if (location) {
      params.set('location', location);
    }
    if (cityId) {
      params.set('cityId', cityId);
    }
    if (location && radius) {
      params.set('radius', radius.toString());
    }

    // Extra filters
    if (isFullRemote) {
      params.set('remoteOption', FULL_REMOTE_FILTER_VALUE);
    }
    if (isPartTime) {
      params.set('employmentType', PART_TIME_FILTER_VALUE);
    }
    if (isFlexitime) {
      params.set('benefit', FLEXITIME_FILTER_VALUE);
    }

    // TODO: Until the rest of jobs is migrated into crate we cannot use history
    window.location.assign(`${ROUTES.search}?${params.toString()}`);
  };

  const filterProps = {
    isFullRemote,
    setIsFullRemote,
    isPartTime,
    setIsPartTime,
    isFlexitime,
    setIsFlexitime,
  };

  return (
    <Background $spacious={spacious}>
      {isStartPage ? <SearchboxStartpageMetadata /> : null}
      <Box>
        {withTeaser ? <Teaser /> : null}
        <Title />
        <SearchBox
          keywordsInput={keywords}
          locationInput={location}
          radiusInput={radius}
          onChangeKeywords={setKeywords}
          onSelectKeywords={setKeywords}
          onChangeLocation={onChangeLocation}
          onSelectLocation={onSelectLocation}
          onSelectRadius={onSelectRadius}
          onSubmit={onSubmit}
          withRecentSearches={withRecentSearches}
          withFilters={withFilters}
          landingFiltersSmall={<SmallScreenFilters {...filterProps} />}
          landingFiltersBig={<BigScreenFilters {...filterProps} />}
        />
      </Box>
    </Background>
  );
};
